import { useFormik } from 'formik';
import {
  Button,
  ErrorMessage,
  TextInput,
} from '@employ-engage/common-components';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export const FindCompanyForm = () => {
  const { t } = useTranslation(['common']);
  const navigate = useNavigate();

  const { handleSubmit, values, errors, touched, handleBlur, handleChange } =
    useFormik({
      initialValues: {
        companyId: 'teva',
      },
      onSubmit: (values) => {
        navigate(`/${values.companyId}/form`);
      },
      validationSchema: Yup.object({
        companyId: Yup.string()
          .required('Required')
          .matches(
            /^[a-z0-9]+(-[a-z0-9]+)*$/,
            'Must be lowercase, numbers, and hyphens only'
          ),
      }),
    });

  const [searchParams] = useSearchParams();

  useEffect(() => {
    const companyIdFromParam = searchParams.get('companyId');
    if (companyIdFromParam) {
      navigate(`/${companyIdFromParam}/form`);
    }
  }, [searchParams, navigate]);

  return (
    <form onSubmit={handleSubmit} className="flex flex-col items-center">
      <label htmlFor="companyId" className="mb-4 text-lg">
        {t('Enter your company ID to begin:')}
      </label>
      <TextInput
        type="text"
        id="companyId"
        value={values.companyId}
        handleChange={handleChange}
        handleBlur={handleBlur}
        className="border border-gray-300 rounded-md p-2 mb-4"
        placeholder={t('Company ID')}
      />
      <ErrorMessage errors={errors.companyId} touched={!!touched.companyId} />
      <Button type="submit" variant={'primary'} size={'large'}>
        {t('Submit')}
      </Button>
    </form>
  );
};

export default FindCompanyForm;
